<h1 mat-dialog-title>Supprimer des crédits</h1>
<div mat-dialog-content>
  <div>
    <div class="d-flex flex-column px-2">
      <mat-form-field>
        <mat-label>Nombre de crédits</mat-label>
        <input matInput placeholder="Ex. 50" value="50" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Commentaire</mat-label>
        <textarea matInput placeholder="Ex. Fin de test gratuit"></textarea>
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end mt-3">
  <button mat-raised-button color="primary" class="me-2">Supprimer</button>
  <button mat-button>Annuler</button>
</div>
